/**
 * default-size.js — Anything AF
 *
 * Pre-selects size L on product pages.
 *
 * Why this exists: the theme selects `selected_or_first_available_variant`, which follows
 * variant order. Variant order and the Size option's display order are the same underlying
 * ordering in Shopify, so making L the default by reordering variants also drags "L" to the
 * front of the size list (L, XS, S, M, XL...). This script lets variant order stay in proper
 * size order (XS first) while the page still opens on L.
 *
 * It deliberately does NOT compute prices, media or the add-to-cart variant itself. It sets the
 * Size control and fires the theme's own `change` event, so <variant-picker> performs its normal
 * re-render and every dependent block updates through supported code paths.
 *
 * It does nothing when:
 *   - the URL already carries ?variant= (an explicit choice, or a link from elsewhere)
 *   - there is no option named Size, or no L value
 *   - L is not purchasable
 *   - the shopper has already interacted with the page
 */
(function () {
  'use strict';

  var TARGET = 'L';

  function isSizeName(name) {
    return typeof name === 'string' && name.trim().toLowerCase() === 'size';
  }

  function preselect(picker) {
    if (!picker || picker.dataset.defaultSizeApplied === 'true') return;

    // An explicit ?variant= always wins — never override a deliberate choice.
    try {
      if (new URL(window.location.href).searchParams.get('variant')) return;
    } catch (e) {
      return;
    }

    var applied = false;

    // Dropdown style (what this store uses).
    var selects = picker.querySelectorAll('select.variant-option__select');
    for (var i = 0; i < selects.length && !applied; i++) {
      var select = selects[i];
      var opts = select.options;
      var isSize = false;
      for (var j = 0; j < opts.length; j++) {
        if (isSizeName(opts[j].dataset.optionName)) { isSize = true; break; }
      }
      if (!isSize) continue;

      for (var k = 0; k < opts.length; k++) {
        var opt = opts[k];
        if (String(opt.value).trim().toUpperCase() !== TARGET) continue;
        if (opt.selected) return;                    // already on L, nothing to do
        if (/unavailable/i.test(opt.textContent)) return;  // L not purchasable here
        select.value = opt.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        applied = true;
        break;
      }
    }

    // Button/radio style, in case the picker is ever switched away from dropdowns.
    if (!applied) {
      var radios = picker.querySelectorAll('input[type="radio"][data-option-name]');
      for (var r = 0; r < radios.length; r++) {
        var radio = radios[r];
        if (!isSizeName(radio.dataset.optionName)) continue;
        if (String(radio.value).trim().toUpperCase() !== TARGET) continue;
        if (radio.checked) return;
        if (radio.dataset.optionAvailable === 'false') return;
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
        applied = true;
        break;
      }
    }

    if (applied) picker.dataset.defaultSizeApplied = 'true';
  }

  function run() {
    var pickers = document.querySelectorAll('variant-picker[data-template-product-match="true"]');
    for (var i = 0; i < pickers.length; i++) preselect(pickers[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
})();
